// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"64b27b36","806":"f8d6f6bc","846":"41b71b44","950":"39c9a4ce"}[chunkId] + ".chunk.css";
};